import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getDefaultAccount } from "constants/apiUrls";
import { DefaultPaymentMethodType } from "types/defaultAccount";
const defaultAccountApi = createApi({
  reducerPath: "defaultAccountApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_URL }),
  endpoints: (builder) => ({
    defaultAccount: builder.query<DefaultPaymentMethodType, { uuid: string }>({
      query: (arg) => {
        const { uuid } = arg;
        const mandatoryHeaders = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
          Authorization: `Bearer ${JSON.parse(
            localStorage.getItem("token") || ""
          )}`,
        };
        return {
          url: getDefaultAccount(uuid),
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useDefaultAccountQuery, useLazyDefaultAccountQuery } =
  defaultAccountApi;
export default defaultAccountApi;
